<template>
  <article class="page" v-if="episode">
    <hero :episode="episode" :comments="episode.comments.length"></hero>
    <section class="postContent">
      <div class="container" v-html="episodeContent"></div>
      <footer class="episodeFooter container">
        <div class="episodeSponsors" v-if="episode.sponsors">
          <h3>Sponsors for this Episode</h3>
          <div v-html="episode.sponsors"></div>
        </div>
        <div class="topicsTags" v-if="episode.tags || topics">
          <div v-if="topics && topics.length">
            <h5>Topics</h5>
            <p>
              <span v-for="(topic, index) in topics">
                <router-link :to="'/category/' + topic.slug">
                  <span v-html="topic.name"></span>
                </router-link>
                <span v-if="(index + 1) < topics.length" class="sep"> &bull; </span>
              </span>
            </p>
          </div>
          <div v-if="episode.tags && episode.tags.length">
            <h5>Tags</h5>
            <p>
              <span v-for="(tag, index) in episode.tags">
                <router-link :to="'/tag/' + tag.slug">
                  <span v-html="tag.name"></span>
                </router-link>
                <span v-if="(index + 1) < episode.tags.length" class="sep"> &bull; </span>
              </span>
            </p>
          </div>
        </div>
        <div class="episodeCta" v-if="episode.ctaQuestion || episode.ctaDescription">
          <h2 v-if="episode.ctaQuestion" v-html="episode.ctaQuestion"></h2>
          <div v-if="episode.ctaDescription" v-html="episode.ctaDescription"></div>
        </div>
        <div class="transcript" v-if="episode.transcript">
          <h2>Podcast Transcript</h2>
          <div v-html="episodeTranscript"></div>
          <p><button class="button is-primary" @click="transcriptExpanded = !transcriptExpanded">{{ transcriptExpanded ? 'Show Less' : 'Show More' }}</button></p>
        </div>
      </footer>
    </section>
    <section class="postContent commentsContent">
      <div class="container">
        <comments :comments="episode.comments" :postId="episode.id"></comments>
      </div>
    </section>
  </article>
</template>

<script>
import Hero from '@/components/episode/Hero'
import Comments from '@/components/common/Comments'

export default {
  name: 'episode',
  props: ['episode'],
  data: () => ({
    transcriptExpanded: false
  }),
  mounted () {
    window.instgrm.Embeds.process()
    window.twttr.widgets.load()
  },
  computed: {
    episodeTranscript () {
      if (this.transcriptExpanded) {
        return this.episode.transcript
      } else {
        let splitTranscript = this.episode.transcript.split('</p>')
        return splitTranscript.slice(0, 2).join('</p>') + '</p>'
      }
    },
    topics () {
      if (this.episode && this.episode.topics) {
        return this.episode.topics.filter(topic => {
          return topic.name !== 'PODCAST'
        })
      }
    },
    episodeContent () {
      let vm = this
      if (vm.episode && vm.episode.content) {
        let content = vm.episode.content
        if (process.env.NODE_ENV === 'development') {
          content = content.split('src="http://longestshortesttime').join('src="http://cdn.longestshortesttime')
        }
        return content
      }
    }
  },
  components: {
    Hero,
    Comments
  }
}
</script>

<style lang="sass">
@import ../assets/styles/mixins

.episodeFooter
  margin-top: 40px
  .episodeSponsors
    padding: 20px 0
    border-top: 1px solid #95989A
    h3
      font-size: 28px
      font-weight: bold
      margin-bottom: 12px
    p
      font-size: 20px
      line-height: 36px
      margin-top: 0
      &:last-child
        margin-bottom: 0
    a
      color: inherit
      font-weight: bold
      &:hover
        color: $primary
  .topicsTags
    padding: 20px 0
    border-top: 1px solid #95989A
    h5
      font-weight: bold
      font-size: 18px
      margin-bottom: 10px
    p
      font-size: 14px
      line-height: 1.5
      a
        color: inherit
        font-weight: 300
        &:hover
          color: $primary
    +tablet
      display: flex
      justify-content: space-between
      > div
        width: 47%
        p
          margin-bottom: 0
          span.sep
            margin: 0 5px
  .episodeCta
    border-top: 1px solid #95989A
    padding-top: 10px
    > div
      p:last-child
        margin-bottom: 0
</style>



// WEBPACK FOOTER //
// Episode.vue?4a6a2109